import { render, staticRenderFns } from "./QuoteService.vue?vue&type=template&id=06c2d1be&"
import script from "./QuoteService.vue?vue&type=script&lang=js&"
export * from "./QuoteService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports